export const DEFAULT_NODE = 'paragraph'

export const renderMark = (props: any, editor: any, next: any) => {
  const { children, mark, attributes } = props

  switch (mark.type) {
    case 'bold': {
      return <strong {...attributes}>{children}</strong>
    }
    case 'code': {
      return <code {...attributes}>{children}</code>
    }
    case 'italic': {
      return <em {...attributes}>{children}</em>
    }
    case 'underlined': {
      return <u {...attributes}>{children}</u>
    }
    default: {
      return next()
    }
  }
}

export const renderNode = (props: any, editor: any, next: any) => {
  const { attributes, children, node } = props

  switch (node.type) {
    case 'block-quote': {
      return <blockquote {...attributes}>{children}</blockquote>
    }
    case 'bulleted-list': {
      return <ul {...attributes}>{children}</ul>
    }
    case 'heading-one': {
      return <h1 {...attributes}>{children}</h1>
    }
    case 'heading-two': {
      return <h2 {...attributes}>{children}</h2>
    }
    case 'list-item': {
      return <li {...attributes}>{children}</li>
    }
    case 'ordered-list':
    case 'numbered-list': {
      return <ol {...attributes}>{children}</ol>
    }
    case 'link': {
      const { data } = node
      const href = data.get('href')
      return (
        <a {...attributes} href={href}>
          {children}
        </a>
      )
    }
    default: {
      return next()
    }
  }
}

export const hasMark = (value: any, type: any) => {
  return value.activeMarks.some((mark: any) => mark.type === type)
}

export const hasBlock = (value: any, type: any) => {
  return value.blocks.some((node: any) => node.type === type)
}

export const hasLinks = (value: any) => {
  return value.inlines.some((inline: any) => inline.type === 'link')
}

export const getLinks = (value: any) => {
  const links = value.inlines
    .filter((inline: any) => inline.type === 'link')
    .toArray()
    .map((inline: any) => inline.data.toObject())

  return links
}

export const wrapLink = (editor: any, href: any) => {
  editor.wrapInline({
    type: 'link',
    data: { href }
  })
}

export const unwrapLink = (editor: any) => {
  editor.unwrapInline('link')
}
